import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div className={cn(
      'rounded-[var(--radius-panel)] border border-line bg-surface shadow-[var(--shadow-panel)]',
      className,
    )}>
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action }: {
  title: ReactNode; subtitle?: ReactNode; action?: ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-4 border-b border-line px-5 py-4">
      <div className="min-w-0">
        <h2 className="truncate text-sm font-semibold text-ink">{title}</h2>
        {subtitle && <p className="mt-0.5 text-xs text-ink-muted">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

/**
 * `badge` is for status that describes the page - a role, a read-only marker.
 * It belongs beside the title, not in `action`: a pill is not a control, and
 * mixing one into a row of buttons is what makes the row look ragged.
 */
export function PageHeader({ title, subtitle, badge, action }: {
  title: ReactNode; subtitle?: ReactNode; badge?: ReactNode; action?: ReactNode;
}) {
  return (
    <header className="mb-6 flex flex-wrap items-center justify-between gap-4">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-xl font-semibold text-ink">{title}</h1>
          {badge}
        </div>
        {subtitle && <p className="mt-1 text-sm text-ink-muted">{subtitle}</p>}
      </div>
      {action && <div className="flex flex-wrap items-center gap-2">{action}</div>}
    </header>
  );
}
